import styled from "styled-components";

export const OrderStatusIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  padding: 12px 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 1.4rem;
  font-weight: 400;
`;

export const StatusTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusText = styled.span<{ color: string; accent?: boolean }>`
  font-size: ${(props) => (props.accent ? "1.3rem" : "1.2rem")};
  font-weight: ${(props) => (props.accent ? "700" : "600")};
  letter-spacing: -0.05em;
  transition: all 0.2s ease;

  color: ${(props) => {
    switch (props.color) {
      case "COMPLETED_REVIEW":
        return props.theme.colors.COMPLETED_REVIEW || "#3B82F6";
      case "TAX_INVOICE_REQUEST_COMPLETED":
        return props.theme.colors.TAX_INVOICE_REQUEST_COMPLETED || "#10B981";
      case "TAX_INVOICE_ERROR":
        return props.theme.colors.TAX_INVOICE_ERROR || "#EF4444";
      case "TAX_INVOICE_PUBLISHED_COMPLETED":
        return props.theme.colors.TAX_INVOICE_PUBLISHED_COMPLETED || "#8B5CF6";
      case "COMPLETED":
        return props.theme.colors.COMPLETED || "#059669";
      default:
        return "#6B7280";
    }
  }};
`;

export const StatusArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  border-radius: 50%;
  position: relative;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &::after {
    content: "";
    width: 6px;
    height: 6px;
    border-right: 2px solid #6b7280;
    border-top: 2px solid #6b7280;
    transform: rotate(45deg);
    margin-left: 1px;
  }
`;

export const StatusBadge = styled.div<{ variant: string }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: -0.01em;

  background: ${(props) => {
    switch (props.variant) {
      case "COMPLETED_REVIEW":
        return `linear-gradient(135deg, ${
          props.theme.colors.COMPLETED_REVIEW || "#3B82F6"
        }15, ${props.theme.colors.COMPLETED_REVIEW || "#3B82F6"}25)`;
      case "TAX_INVOICE_REQUEST_COMPLETED":
        return `linear-gradient(135deg, ${
          props.theme.colors.TAX_INVOICE_REQUEST_COMPLETED || "#10B981"
        }15, ${
          props.theme.colors.TAX_INVOICE_REQUEST_COMPLETED || "#10B981"
        }25)`;
      case "TAX_INVOICE_ERROR":
        return `linear-gradient(135deg, ${
          props.theme.colors.TAX_INVOICE_ERROR || "#EF4444"
        }15, ${props.theme.colors.TAX_INVOICE_ERROR || "#EF4444"}25)`;
      case "TAX_INVOICE_PUBLISHED_COMPLETED":
        return `linear-gradient(135deg, ${
          props.theme.colors.TAX_INVOICE_PUBLISHED_COMPLETED || "#8B5CF6"
        }15, ${
          props.theme.colors.TAX_INVOICE_PUBLISHED_COMPLETED || "#8B5CF6"
        }25)`;
      case "COMPLETED":
        return `linear-gradient(135deg, ${
          props.theme.colors.COMPLETED || "#059669"
        }15, ${props.theme.colors.COMPLETED || "#059669"}25)`;
      default:
        return "linear-gradient(135deg, #F3F4F615, #F3F4F625)";
    }
  }};

  border: 1px solid
    ${(props) => {
      switch (props.variant) {
        case "COMPLETED_REVIEW":
          return `${props.theme.colors.COMPLETED_REVIEW || "#3B82F6"}30`;
        case "TAX_INVOICE_REQUEST_COMPLETED":
          return `${
            props.theme.colors.TAX_INVOICE_REQUEST_COMPLETED || "#10B981"
          }30`;
        case "TAX_INVOICE_ERROR":
          return `${props.theme.colors.TAX_INVOICE_ERROR || "#EF4444"}30`;
        case "TAX_INVOICE_PUBLISHED_COMPLETED":
          return `${
            props.theme.colors.TAX_INVOICE_PUBLISHED_COMPLETED || "#8B5CF6"
          }30`;
        case "COMPLETED":
          return `${props.theme.colors.COMPLETED || "#059669"}30`;
        default:
          return "#E5E7EB";
      }
    }};

  color: ${(props) => {
    switch (props.variant) {
      case "COMPLETED_REVIEW":
        return props.theme.colors.COMPLETED_REVIEW || "#3B82F6";
      case "TAX_INVOICE_REQUEST_COMPLETED":
        return props.theme.colors.TAX_INVOICE_REQUEST_COMPLETED || "#10B981";
      case "TAX_INVOICE_ERROR":
        return props.theme.colors.TAX_INVOICE_ERROR || "#EF4444";
      case "TAX_INVOICE_PUBLISHED_COMPLETED":
        return props.theme.colors.TAX_INVOICE_PUBLISHED_COMPLETED || "#8B5CF6";
      case "COMPLETED":
        return props.theme.colors.COMPLETED || "#059669";
      default:
        return "#6B7280";
    }
  }};
`;
